var GROUP_MEMBER = 'GROUP_MEMBER';
var GROUP_MODERATOR = 'GROUP_MODERATOR';
var GROUP_ADMIN = 'GROUP_ADMIN';

module.exports = {
  GROUP_MEMBER,
  GROUP_MODERATOR,
  GROUP_ADMIN,
};
